import { lazy } from "react";

const HomePage = lazy(() => import("../pages/Home/HomePage"));
const BookmarkList = lazy(() => import("../pages/Bookmarks/BookmarkList"));
const CollectionList = lazy(() =>
  import("../pages/Collections/CollectionList")
);
const CollectionDetail = lazy(() =>
  import("../pages/Collections/CollectionDetail")
);
const SpacesList = lazy(() => import("../pages/Spaces/SpacesList"));
const SearchPage = lazy(() => import("../pages/Search/SearchPage"));

// Settings routes
const SettingsMenu = lazy(() => import("../pages/Settings/SettingsMenu"));
const AccountSettings = lazy(() => import("../pages/Settings/AccountSettings"));
const PreferencesSettings = lazy(() =>
  import("../pages/Settings/PreferencesSettings")
);
const IntegrationSettings = lazy(() =>
  import("../pages/Settings/IntegrationSettings")
);
const SecuritySettings = lazy(() =>
  import("../pages/Settings/SecuritySettings")
);
const SubscriptionSettings = lazy(() =>
  import("../pages/Settings/SubscriptionSettings")
);
const DataSettings = lazy(() => import("../pages/Settings/DataSettings"));
const CleanupSettings = lazy(() => import("../pages/Settings/CleanupSettings"));
const TokensSettings = lazy(() => import("../pages/Settings/TokensSettings"));
const RediscoverPage = lazy(() => import("../pages/Rediscover/RediscoverPage"));
const AskPage = lazy(() => import("../pages/Ask/AskPage"));
const ShareTarget = lazy(() => import("../pages/Share/ShareTarget"));

export const authenticatedRoutes = [
  {
    path: "/",
    Component: BookmarkList,
  },
  {
    path: "/home",
    Component: HomePage,
  },
  {
    path: "/bookmarks",
    Component: BookmarkList,
  },
  {
    path: "/collections",
    Component: CollectionList,
  },
  {
    path: "/collections/:uuid",
    Component: CollectionDetail,
  },
  {
    path: "/spaces",
    Component: SpacesList,
  },
  {
    path: "/search",
    Component: SearchPage,
  },
  {
    path: "/settings",
    Component: SettingsMenu,
  },
  {
    path: "/settings/account",
    Component: AccountSettings,
  },
  {
    path: "/settings/preferences",
    Component: PreferencesSettings,
  },
  {
    path: "/settings/integration",
    Component: IntegrationSettings,
  },
  {
    path: "/settings/security",
    Component: SecuritySettings,
  },
  {
    path: "/settings/subscription",
    Component: SubscriptionSettings,
  },
  {
    path: "/settings/data",
    Component: DataSettings,
  },
  {
    path: "/settings/cleanup",
    Component: CleanupSettings,
  },
  {
    path: "/settings/tokens",
    Component: TokensSettings,
  },
  {
    path: "/rediscover",
    Component: RediscoverPage,
  },
  {
    path: "/ask",
    Component: AskPage,
  },
  {
    path: "/share",
    Component: ShareTarget,
  },
];
